<template>
  <div>
    <h1 class="te-notice-page-title co-display-8 mb-8 mt-5 text-center leading-none md:mb-12">
      【重要なお知らせ】「リスキリングを通じたキャリアアップ支援事業」に関する誓約書再提出のお願いについて
    </h1>
    <p class="mb-16 text-right leading-loose md:mb-20">
      掲載日：2026年8月20日
    </p>
    <div class="w-full">
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          概要
        </h3>
        <p class="ml-4 leading-loose">
          現在、テックアカデミーより、経済産業省「リスキリングを通じたキャリアアップ支援事業」をご利用いただいた受講生の皆様へ、誓約書の再提出をお願いするメールをお送りしております。<br>
          本メールはテックアカデミーからの正式なご依頼であり、詐欺や不審なメールではございません。<br>
          お手数をおかけし恐縮ですが、内容をご確認のうえ、ご対応をお願いいたします。
        </p>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          背景・目的
        </h3>
        <ul class="ml-4 list-disc pl-7 leading-loose">
          <li class="mb-2">
            テックアカデミーは、経済産業省「リスキリングを通じたキャリアアップ支援事業」の補助事業者として、受講料の一部キャッシュバック等の支援を提供してまいりました
          </li>
          <li class="mb-2">
            このたび、当該事業事務局と確認を進める中で、受講時およびキャリア面談時にご提出いただいた誓約書について、提出時期の観点から再提出が必要であることが確認されました
          </li>
          <li>
            本事業による補助金受給の要件を満たすために必要な手続きであるため、対象の皆様に再提出をお願いしております
          </li>
        </ul>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          対象となる方
        </h3>
        <ul class="ml-4 list-disc pl-7 leading-loose">
          <li class="mb-2">
            「リスキリングを通じたキャリアアップ支援事業」を活用してTechAcademyの対象講座を受講し、受講料キャッシュバック（返金）を受けられた方
          </li>
          <li>
            対象の方には、<span class="font-bold">受講時にご登録いただいたメールアドレス宛</span>にご案内をお送りしています
          </li>
        </ul>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          テックアカデミーよりお送りしているメールについて
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          以下の内容にてお送りのメールをご確認いただけます。
        </p>
        <ul class="mb-6 ml-4 list-disc pl-7 leading-loose">
          <li class="mb-2">
            <span class="font-bold">送信元アドレス</span>：<span class="te-notice-nowrap">no-reply@techacademy.jp</span>（サービスの正式なドメインとなっております）
          </li>
          <li class="mb-2">
            <span class="font-bold">件名</span>：【重要/要対応】リスキリングを通じたキャリアアップ支援事業を活用したテックアカデミー受講について（もしくは、【重要/要対応】リスキリングを通じたキャリアアップ支援事業を活用したLINEヤフーテックアカデミー受講について）
          </li>
          <li class="mb-2">
            <span class="font-bold">送付時期</span>：2026年7月上旬より順次お送りしており、ご回答いただけていない方には複数回リマインドをお送りしています
          </li>
          <li>
            <span class="font-bold">リンク先</span>：ご提出用フォーム（Googleフォーム）のみで、それ以外のサイトへ誘導することはありません
          </li>
        </ul>
        <p class="mb-6 ml-4 leading-loose">
          上記のメールをご確認いただき、メール内に記載の内容をご対応いただけますと幸いです。
        </p>
        <div class="te-notice-caution ml-4 flex gap-3 p-4 leading-loose">
          <FontAwesomeIcon
            :icon="faCircleExclamation"
            class="fa-fw co-display-9 mt-1 shrink-0 text-co-warning-500"
          />
          <p>
            上記と異なる送信元・件名・リンク先のメールを受け取られた場合は、対応せず、下記お問い合わせ窓口までご連絡ください。
          </p>
        </div>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          安心してご対応いただくために
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          テックアカデミーから以下をお願いすることは<span class="font-bold">一切ありません</span>。
        </p>
        <ul class="mb-4 ml-4 list-disc pl-7 leading-loose">
          <li class="mb-2">
            金銭の振込・支払いのご請求
          </li>
          <li class="mb-2">
            銀行口座の暗証番号、クレジットカード情報のご入力
          </li>
          <li class="mb-2">
            各種サービスのID・パスワードのご入力
          </li>
          <li class="mb-2">
            電子マネー・ギフトカードの購入
          </li>
          <li>
            アプリのインストールや遠隔操作のご依頼
          </li>
        </ul>
        <p class="ml-4 leading-loose">
          また、フォームでご入力いただいた個人情報は、本事業の書類確認の目的にのみ利用し、それ以外の目的では利用いたしません。詳細は<a
            href="/privacypolicy"
            class="te-notice-link"
          >プライバシーポリシー</a>をご確認ください。
        </p>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          お電話でのご連絡について
        </h3>
        <ul class="ml-4 list-disc pl-7 leading-loose">
          <li class="mb-2">
            メールでのご回答が確認できない方には、2026年8月以降、テックアカデミー担当者よりお電話でご連絡させていただく場合があります
          </li>
          <li>
            お電話でも、金銭の振込・支払いの依頼、カード情報など、上記「安心してご対応いただくために」に記載をしている事項をお伺いすることはありません
          </li>
        </ul>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          よくあるご質問
        </h3>
        <div class="te-notice-faq-list ml-4">
          <div class="collapse collapse-plus border-b border-co-gray-200 pl-0">
            <input type="checkbox">
            <div class="collapse-title py-4 pl-4 font-bold leading-loose text-co-gray-700 hover:bg-co-gray-100">
              なぜ今になって再提出が必要なのですか？
            </div>
            <div class="collapse-content pl-4 text-co-gray-600">
              <p class="pb-4 leading-loose">
                本事業の書類確認を進める中で、誓約書の提出時期について再提出が必要であることが確認されたためです。皆様に追加のご請求が発生することはありません。
              </p>
            </div>
          </div>
          <div class="collapse collapse-plus border-b border-co-gray-200 pl-0">
            <input type="checkbox">
            <div class="collapse-title py-4 pl-4 font-bold leading-loose text-co-gray-700 hover:bg-co-gray-100">
              本当にTechAcademyからのメールか確認したいです。
            </div>
            <div class="collapse-content pl-4 text-co-gray-600">
              <p class="pb-4 leading-loose">
                本ページ「テックアカデミーよりお送りしているメールについて」に記載の送信元アドレス・件名をご確認ください。ご不安な場合は、メール内のリンクを使用せず、下記のお問い合わせ窓口まで直接ご連絡ください。
              </p>
            </div>
          </div>
          <div class="collapse collapse-plus border-b border-co-gray-200 pl-0">
            <input type="checkbox">
            <div class="collapse-title py-4 pl-4 font-bold leading-loose text-co-gray-700 hover:bg-co-gray-100">
              提出した個人情報は何に使われますか？
            </div>
            <div class="collapse-content pl-4 text-co-gray-600">
              <p class="pb-4 leading-loose">
                本事業の書類確認の目的にのみ利用し、目的外利用はいたしません。
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          お問い合わせ窓口
        </h3>
        <p class="ml-4 leading-loose">
          お問い合わせフォーム：<a
            href="/contact"
            class="te-notice-link"
          >https://techacademy.jp/contact</a><br>
          「メールの真偽を確認したい」というお問い合わせも歓迎しております。
        </p>
      </div>

      <div>
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          運営会社情報
        </h3>
        <p class="ml-4 leading-loose">
          運営会社の詳細は<a
            href="/company"
            class="te-notice-link"
          >運営会社情報</a>、個人情報のお取り扱いは<a
            href="/privacypolicy"
            class="te-notice-link"
          >プライバシーポリシー</a>をご確認ください。<br>
          「リスキリングを通じたキャリアアップ支援事業」の詳細は、<a
            href="https://careerup.reskilling.go.jp/"
            target="_blank"
            class="te-notice-link"
          >経済産業省の公式サイト</a>をご確認ください。
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
    return {
      faCircleExclamation,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title:
        '【重要】「リスキリングを通じたキャリアアップ支援事業」に関する誓約書再提出のお願い｜テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '経済産業省「リスキリングを通じたキャリアアップ支援事業」をご利用いただいた受講生の皆様への、誓約書再提出のお願いに関するご案内です。',
            ogUrl: '/benefits/reskilling-notice',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-notice-page-title {
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

.te-notice-nowrap {
  white-space: nowrap;
}

.te-notice-caution {
  background: #fdf6ec;
  border-left: 5px solid #f0ad4e;
}

.te-notice-faq-list .collapse-title,
.te-notice-faq-list :where(.collapse > input[type="checkbox"]) {
  min-height: 2.875rem;
}

.te-notice-faq-list .collapse-plus > .collapse-title::after {
  top: 0.875rem;
  right: 1rem;
  font-size: 1.5rem;
  color: #747474;
}

.te-notice-link {
  @media (max-width: 576px) {
    font-size: .6875rem;
  }
}
</style>
